(() => {
  'use strict';
  if (window.RavinShippingUnlockLoaded) return;
  window.RavinShippingUnlockLoaded = true;
  const STORAGE_KEY = 'rv_shipping_governorate_v1';
  const instances = new Set();
  let city = '';
  let lastCart = null;
  let refreshTimer = null;
  let refreshGeneration = 0;
  try { city = localStorage.getItem(STORAGE_KEY) || ''; } catch (_) {}

  const money = (cents, ar) => {
    const formatted = new Intl.NumberFormat('en-EG', {maximumFractionDigits:2}).format((Math.max(0,cents)||0)/100);
    return ar ? formatted + ' ج.م' : 'EGP ' + formatted;
  };
  const shortfall = (n) => Math.ceil(Math.max(0,n)/100);
  const renderedMoney = (amount, ar) => {
    const formatted = new Intl.NumberFormat('en-EG',{maximumFractionDigits:0}).format(amount);
    return ar ? formatted + ' ج.م' : 'EGP ' + formatted;
  };

  function locate(root) {
    if (root.dataset.rvShippingPlace === 'product') {
      const target = document.querySelector('[data-ravin-pdp-editorial] .rpa-pdp-right .rpa-pdp-purchase-controls') ||
                     document.querySelector('[data-ravin-pdp-editorial] .rpa-pdp-right [data-price-wrapper]');
      if (!target) return false;
      target.insertAdjacentElement('afterend', root);
      return true;
    }
    const target = document.querySelector('#main-cart-footer .cart__blocks');
    if (!target) return false;
    target.prepend(root);
    return true;
  }

  function view(root, data) {
    const count = Number(data?.item_count ?? root.dataset.rvShippingCount) || 0;
    const raw = Math.max(0,Number(data?.total_price ?? root.dataset.rvShippingTotal) || 0);
    if (root.dataset.rvShippingCurrency !== 'EGP') { root.hidden = true; return; }
    root.hidden = count < 1;
    if (count < 1) return;
    const select = root.querySelector('[data-rv-ship-city]');
    const opt = Array.from(select?.options || []).find(o => o.value === city && o.dataset.goal);
    if (select) select.value = opt ? city : '';
    const result = root.querySelector('[data-rv-ship-result]');
    const choose = root.querySelector('[data-rv-ship-choose]');
    if (!opt) { result.hidden = true; choose.hidden = false; return; }
    result.hidden = false;
    choose.hidden = true;
    const goal = Number(opt.dataset.goal);
    if (!Number.isFinite(goal) || goal <= 0) { result.hidden = true; choose.hidden = false; return; }
    const total = Math.max(0,Math.min(raw, Number(data?.projected_total ?? raw)));
    const remaining = Math.max(0,goal-total);
    const ar = root.dataset.rvShippingAr === 'true';
    const isUnlocked = remaining === 0;
    root.dataset.rvShippingUnlocked = String(isUnlocked);
    const progress = Math.max(0,Math.min(100, total / goal * 100));
    root.querySelector('[data-rv-ship-current]').textContent = money(total,ar);
    root.querySelector('[data-rv-ship-goal]').textContent = renderedMoney(Math.ceil(goal/100),ar);
    root.querySelector('[data-rv-ship-fill]').style.width = progress.toFixed(2) + '%';
    const track = root.querySelector('[data-rv-ship-progress]');
    track.setAttribute('aria-valuenow',String(Math.round(progress)));
    track.setAttribute('aria-valuetext', ar ? 'تم ' + Math.round(progress) + '٪ من هدف الشحن' : Math.round(progress) + '% to free delivery');
    const msg = root.querySelector('[data-rv-ship-message]');
    msg.textContent = isUnlocked ?
      (ar ? 'اتفتحلك الشحن المجاني مع الدفع المسبق أو التقسيط!' : 'FREE DELIVERY UNLOCKED with prepaid payment or installments!') :
      (ar ? 'زوّد ' + renderedMoney(shortfall(remaining),true) + ' على طلبك وخلي الشحن علينا' : 'Add ' + renderedMoney(shortfall(remaining),false) + ' more to unlock FREE delivery');
  }

  function broadcast(data) {
    lastCart = data;
    for (const root of instances) if (root.isConnected) view(root,data);
  }

  async function getProjectedTotal() {
    try {
      const base = window.routes?.cart_url || '/cart';
      const url = base + (base.includes('?') ? '&' : '?') + 'sections=cart-footer';
      const response = await fetch(url,{credentials:'same-origin',headers:{'Accept':'application/json'}});
      if (!response.ok) return null;
      const content = await response.json();
      const html = content['cart-footer'];
      if (!html) return null;
      const documentFragment = new DOMParser().parseFromString(html,'text/html');
      const node = documentFragment.querySelector('[data-ravin-cart-total]');
      return node ? Number(node.dataset.ravinCartTotal) : null;
    } catch (_) { return null; }
  }

  async function refresh() {
    const requestId = ++refreshGeneration;
    try {
      const base = window.routes?.cart_url || '/cart';
      const response = await fetch(base + '.js',{credentials:'same-origin',headers:{'Accept':'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      let projection = await getProjectedTotal();
      if (requestId !== refreshGeneration) return;
      const data = {item_count:cart.item_count,total_price:cart.total_price,projected_total:Number.isFinite(projection) ? Math.min(projection,cart.total_price) : cart.total_price};
      broadcast(data);
    } catch (_) {}
  }
  function queueRefresh(delay) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh,delay || 130);
  }

  function init() {
    document.querySelectorAll('[data-rv-shipping-unlock]').forEach(root => {
      if (instances.has(root)) return;
      if (!locate(root)) return;
      instances.add(root);
      const select = root.querySelector('[data-rv-ship-city]');
      select.addEventListener('change',() => {
        city = select.value;
        try { if (city) localStorage.setItem(STORAGE_KEY,city); else localStorage.removeItem(STORAGE_KEY); } catch (_) {}
        for (const component of instances) if (component.isConnected) view(component,lastCart);
      });
      view(root,lastCart);
    });
  }

  const start = () => {
    init();
    queueRefresh(0);
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
      subscribe(window.PUB_SUB_EVENTS.cartUpdate,()=>queueRefresh(160));
    }
    document.addEventListener('cart:updated',()=>queueRefresh(160));
    document.addEventListener('submit', event => {
      const form = event.target;
      if (form?.matches?.('form[data-product-form], form[action*="/cart/add"]')) queueRefresh(1100);
    },true);
    document.addEventListener('cart:refresh',()=>queueRefresh(160));
    document.addEventListener('change', e => {
      if (e.target.closest('cart-items, #main-cart-items, cart-drawer')) queueRefresh(750);
    },true);
    document.addEventListener('click', e => {
      if (e.target.closest('[data-add-to-cart], [data-sticky-add-to-cart], [data-rcc-add-form] .rcc__add, .cart-remove-button, cart-remove-button')) {
        queueRefresh(1200);
      }
    },true);
    document.addEventListener('shopify:section:load',()=>{init();queueRefresh(120);});
    window.addEventListener('pageshow',()=>queueRefresh(120));
    const items = document.getElementById('main-cart-items');
    if (items) new MutationObserver(() => queueRefresh(250)).observe(items,{childList:true,subtree:false});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();